var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import Uploader from "../../common/components/uploader.vue";
import TreeSelectPanel from "../../common/components/TreeSelectPanel.vue";
import InputUploader from "../../common/components/InputUploader.vue";
import UE from "../../common/components/Ueditor.vue";
import GoodService from "../../api/GoodService";
import SupplierService from "../../api/SupplierService";
import GLOBAL_VUE from "../../globalVue";
import { Loading } from 'element-ui';
import Specification from './components/Specification.vue';
import ArticleList from "../../components/alert/ArticleList.vue";
import Editor from "./components/Editor.vue";
import AccoutCheckService from '@/api/AccoutCheckService';
function createModel() {
    return {
        goods_name: "",
        goods_pinyin: "",
        goods_type_id: undefined,
        unit_format: "",
        single_unit_id: "",
        store_unit_id: "",
        apply_format: "",
        good_unit_id: "",
        apply_unit_weight: "",
        min_order_amount: "",
        order_multiple: "",
        goods_price: "",
        goods_code: "",
        producer: "",
        goods_brand_id: "",
        storage_condition_id: 1,
        storage_condition_range: [20, 25],
        shelflife: "7",
        product_area: undefined,
        food_standard: "",
        bar_code: "",
        is_publish: true,
        selling_point: "",
        catering_type: [],
        cook_type: [],
        main_ingredients: "",
        taste: [],
        flavor: [],
        check_report_pic: [],
        goods_detail_pic: [],
        good_images: [],
        good_explain: "",
        goods_attr_id: "",
        is_weigh: "0",
        check_type: [1, 2, 3],
        inventory_unit_id: 1,
        sales_unit_id: 1,
        sales_unit_coefficient: "1",
        sales_is_weigh: "0",
        sales_weigh_unit_coefficient: "1",
        purchase_unit_id: 1,
        purchase_format: "1",
        purchase_is_weigh: "0",
        purchase_weigh_unit_coefficient: "1",
        goods_format_list: [],
        sort: "",
        supplier_upper_id: "",
        sale_init: 0,
        sale_multiple: 1,
        exp_num: 7,
        exp_unit: 1,
        strikethrough_price: '',
        is_publish_list: {
            is_publish_goods_tag: true,
            is_publish_goods_pic: true,
            is_publish_goods_explain: true,
            is_publish_goods_sale: true,
        },
        good_brand_name: '',
        product_area_name: '',
        storage_condition_name: '常温',
        purchase_unit_name: '',
        tax_type_code: ''
    };
}
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.goodId = null;
        _this.defaultOpen = ["1", "2", "3", "4"];
        _this.goodModel = createModel();
        _this.defaultMsg = "";
        _this.categoryList = [];
        _this.stdList = [];
        _this.brandList = [];
        _this.storeconList = [];
        _this.producerList = [];
        _this.attrList = [];
        _this.checkTypeList = [];
        _this.shopTypeList = [];
        _this.chuGoodList = [];
        _this.tasteList = [];
        _this.mouthfeels = [];
        _this.cityOptions = Array.from({ length: 25 }, function (item, index) { return ({ id: index, name: '上海' }); });
        _this.cateringType = [];
        _this.cookType = [];
        _this.uploaderId = "uid";
        _this.is_apply_auth = 0;
        _this.goodtypePanelShow = false;
        _this.purchasingUnit = '';
        _this.inventoryUnit = '';
        _this.salesUnit = '';
        _this.weighUnit = '';
        _this.supplierupperOptions = [];
        _this.purchaseFormatType = 1;
        _this.purchase_format_switch = '';
        _this.salesUnitCoefficientType = 1;
        _this.sales_unit_coefficient_switch = '';
        _this.is_confirm = 0;
        _this.isWeighList = [
            {
                name: "1",
                value: "是"
            },
            {
                name: "0",
                value: "否"
            }
        ];
        _this.ExpUnitList = [];
        _this.storageExplain = '';
        _this.loadingSearch = false;
        _this.tax_type_options = [];
        _this.config = {
            initialFrameWidth: null,
            initialFrameHeight: 400,
            autoHeightEnabled: true,
            zIndex: 9999,
        };
        return _this;
    }
    default_1.prototype.initGoodsCategory = function () {
        var _this = this;
        this.loadingSearch = true;
        this.accountService.getGoodsCategory({ keyword: '' })
            .then(function (res) {
            var _a = res.data, data = _a.data, success = _a.success;
            if (success) {
                _this.tax_type_options = (data || []);
            }
        }).finally(function () {
            _this.loadingSearch = false;
        });
    };
    default_1.prototype.updateStorageCondition = function () {
        var conditionMap = {
            '': [0, 0],
            1: [20, 25],
            2: [-20, -1],
            3: [0, 10],
            4: [10, 20]
        };
        var id = this.goodModel.storage_condition_id;
        this.goodModel.storage_condition_range = conditionMap[id];
    };
    default_1.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    default_1.prototype.areaNormalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    default_1.prototype.taxNormalizer = function (node) {
        return {
            id: node.type_code,
            label: node.type_name,
            children: node.children,
        };
    };
    default_1.prototype.dataProcess = function (data) {
        data.check_report_pic = data.check_report_pic.map(function (item) {
            return {
                "url": item.response && item.response.data ? item.response.data.full_path : item.url
            };
        });
        data.goods_detail_pic = data.goods_detail_pic.map(function (item) {
            return {
                "url": item.response && item.response.data ? item.response.data.full_path : item.url
            };
        });
        data.good_images = data.good_images.map(function (item) {
            return {
                "uid": item.uid,
                "name": item.name,
                "url": item.response && item.response.data ? item.response.data.full_path : item.url,
                "selected": item.selected ? true : false
            };
        });
        var brandValues = this.brandList.map(function (item) { return item.value; });
        data.is_brand_add = brandValues.indexOf(data.goods_brand_id) == -1;
        if (this.goodId) {
            data.goods_id = this.goodId;
        }
        return data;
    };
    default_1.prototype.save = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            console.log(res, 777);
            if (!res) {
                _this.$validator.errors.items.forEach(function (error) {
                    console.log(error.field, error.msg);
                });
                _this.$message.error("请填写所有必填字段，并且按字段格式要求填写");
                return;
            }
            if (_this.goodModel.purchase_weigh_unit_coefficient > 100 || _this.goodModel.sales_weigh_unit_coefficient > 100) {
                _this.$message.error("称重单位系数的范围 0-100");
                return;
            }
            var filter = function (item) {
                return /^[-\d]+$/.test(item);
            };
            if (_this.goodModel.storage_condition_range.filter(filter).length === 1) {
                _this.$message.error("请填写完整存储条件");
                return;
            }
            if (_this.goodModel.order_multiple !== '' && _this.goodModel.order_multiple <= 0) {
                _this.$message.error("订货倍数必须是大于0的整数");
                return;
            }
            var isPublishList = JSON.parse(JSON.stringify(_this.goodModel.is_publish_list));
            _this.goodModel.exp_unit_name = _this.ExpUnitList[_this.goodModel.exp_unit - 1].name;
            _this.goodModel.is_publish_list['is_publish_goods_tag'] = _this.goodModel.is_publish_list['is_publish_goods_tag'] && _this.goodModel.is_publish ? 1 : 0;
            _this.goodModel.is_publish_list['is_publish_goods_pic'] = _this.goodModel.is_publish_list['is_publish_goods_pic'] && _this.goodModel.is_publish ? 1 : 0;
            _this.goodModel.is_publish_list['is_publish_goods_explain'] = _this.goodModel.is_publish_list['is_publish_goods_explain'] && _this.goodModel.is_publish ? 1 : 0;
            _this.goodModel.is_publish_list['is_publish_goods_sale'] = _this.goodModel.is_publish_list['is_publish_goods_sale'] && _this.goodModel.is_publish ? 1 : 0;
            _this.goodModel.good_explain = _this.storageExplain;
            if (_this.purchaseFormatType == 2) {
                _this.goodModel.purchase_format = Number(1 / +_this.purchase_format_switch).toFixedNoZero(4);
            }
            if (_this.salesUnitCoefficientType == 2) {
                _this.goodModel.sales_unit_coefficient = Number(1 / +_this.sales_unit_coefficient_switch).toFixedNoZero(4);
            }
            console.log(_this.goodModel);
            var data = JSON.parse(JSON.stringify(_this.goodModel));
            data = _this.dataProcess(data);
            data.is_confirm = _this.is_confirm;
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.goodAddSave({ data: JSON.stringify(data) }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 0) {
                    _this.$message.success("保存成功");
                    if (!_this.goodId) {
                        if (_this.goodModel.is_publish) {
                            window._czc.push(["_trackEvent", '新增货品', '保存', '勾选补充信息']);
                        }
                        else {
                            window._czc.push(["_trackEvent", '新增货品', '保存', '未勾选补充信息']);
                        }
                    }
                    ;
                    if (_this.opener && _this.opener.getGoodList) {
                        _this.opener.getGoodList();
                    }
                    ;
                    setTimeout(function () {
                        GLOBAL_VUE.$emit("closeTab", _this);
                        window._czc.push(["_trackEvent", '货品列表', '编辑货品']);
                    }, 500);
                    return;
                }
                else if (res.data.code == 3) {
                    _this.$confirm('货品名称已存在，是否确认？', '提示')
                        .then(function () {
                        _this.is_confirm = 1;
                        _this.save();
                    }, function () { });
                    return;
                }
                var instance = _this.$dialog(ArticleList, {
                    data: {
                        resData: res.data,
                        modelType: 'specAndGood',
                        sureButtonText: res.data.code == 12 ? "确定" : '知道了',
                        showCancelButton: res.data.code == 12
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350,
                    closeBtn: false,
                }).instance;
            }).catch(function (err) {
                _this.goodModel.is_publish_list = isPublishList;
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        });
    };
    default_1.prototype.created = function () {
        this.service = GoodService.getInstance();
        this.supplierService = SupplierService.getInstance();
        this.accountService = AccoutCheckService.getInstance();
        this.initGoodsCategory();
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        this.is_apply_auth = this.$store.state.config.is_apply_auth;
        var loadingInstance = Loading.service({ fullscreen: true });
        Promise.all([
            this.getGoodtype(),
            this.getStd(),
            this.getBrand(),
            this.getStorage(),
            this.getArea(),
            this.getCateringType(),
            this.getCookType(),
            this.getTastes(),
            this.getMouthFeels(),
            this.getAttr(),
            this.getCheckType(),
            this.getSupplierupperOptions(),
            this.getExpUnit()
        ]).then(function (result) {
            loadingInstance.close();
            if (_this.goodId) {
                _this.getInfor();
            }
            ;
        }).catch(function (error) {
            loadingInstance.close();
            console.log(error);
        });
    };
    default_1.prototype.validateNumericInput = function (value, field, fieldName, minValue, maxValue) {
        if (value !== null && value !== undefined && value !== '') {
            var regex = /^(\d*\.\d{0,2}|\d+)$/;
            if (!regex.test(value)) {
                this.$message.error("\u8BF7\u8F93\u5165\u6570\u5B57\uFF0C\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF0C" + fieldName + "\u5FC5\u987B\u5728" + minValue + "\u548C" + maxValue + "\u4E4B\u95F4");
                this.goodModel[field] = '1';
            }
            if (parseFloat(value) < minValue) {
                this.$message.error("\u8BF7\u8F93\u5165\u6570\u5B57\uFF0C\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF0C" + fieldName + "\u5FC5\u987B\u5728" + minValue + "\u548C" + maxValue + "\u4E4B\u95F4");
                this.goodModel[field] = minValue;
            }
            if (parseFloat(value) > maxValue) {
                this.$message.error("\u8BF7\u8F93\u5165\u6570\u5B57\uFF0C\u6700\u591A\u4E24\u4F4D\u5C0F\u6570\uFF0C" + fieldName + "\u5FC5\u987B\u5728" + minValue + "\u548C" + maxValue + "\u4E4B\u95F4");
                this.goodModel[field] = maxValue;
            }
        }
    };
    default_1.prototype.getExpUnit = function () {
        var _this = this;
        this.service.getExpUnit().then(function (res) {
            _this.ExpUnitList = Array.isArray(res.data.data) ? res.data.data : [];
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getPinyin = function (e) {
        var _this = this;
        var value = e.target.value;
        if (value) {
            this.service.getPinyin({ name: value }).then(function (res) {
                _this.goodModel.goods_pinyin = res.data.data.pinyin;
            });
        }
        else {
            this.goodModel.goods_pinyin = '';
        }
    };
    default_1.prototype.getTaxiType = function () {
        var _this = this;
        if (/^\s*$/.test(this.goodModel.goods_name)) {
            return;
        }
        this.service.getTaxiByGoodsName({ goods_name: this.goodModel.goods_name }).then(function (res) {
            console.log('name change res>>>', res);
            if (res.data.success) {
                _this.goodModel.tax_type_code = res.data.data.tax_type_code;
                _this.goodModel.tax_type_id = res.data.tax_type_id;
                _this.goodModel.tax_rate = res.data.tax_rate;
            }
        });
    };
    default_1.prototype.getGoodtype = function () {
        var _this = this;
        var params = {
            level: 4
        };
        return this.service.getCategory(params).then(function (res) {
            if (res.data.success) {
                _this.categoryList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getStd = function () {
        var _this = this;
        return this.service.getUnit().then(function (res) {
            if (res.data.success) {
                _this.stdList = res.data.data;
                _this.stdList.some(function (std) {
                    if (std.value == _this.goodModel.sales_unit_id) {
                        _this.purchasingUnit = std.name;
                        return true;
                    }
                });
                _this.stdList.some(function (std) {
                    if (std.value == _this.goodModel.inventory_unit_id) {
                        _this.inventoryUnit = std.name;
                        return true;
                    }
                });
                _this.stdList.some(function (std) {
                    if (std.value == _this.goodModel.sales_unit_id) {
                        _this.salesUnit = std.name;
                        return true;
                    }
                });
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getBrand = function () {
        var _this = this;
        return this.service.getBrand().then(function (res) {
            if (res.data.success) {
                _this.brandList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getStorage = function () {
        var _this = this;
        return this.service.getStorage().then(function (res) {
            if (res.data.success) {
                _this.storeconList = res.data.data || [];
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getAttr = function () {
        var _this = this;
        return this.service.getAttr().then(function (res) {
            if (res.data.success) {
                _this.attrList = res.data.data || [];
                if (res.data.data.length) {
                    _this.goodModel.goods_attr_id = _this.attrList[0].goods_attr_id;
                }
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getCheckType = function () {
        var _this = this;
        return this.service.getCheckType().then(function (res) {
            if (res.data.success) {
                _this.checkTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getArea = function () {
        var _this = this;
        return this.service.getArea().then(function (res) {
            if (res.data.success) {
                _this.producerList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getCateringType = function () {
        var _this = this;
        return this.service.getCateringType().then(function (res) {
            if (res.data.success) {
                _this.cateringType = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getCookType = function () {
        var _this = this;
        return this.service.getCookType().then(function (res) {
            if (res.data.success) {
                _this.cookType = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getTastes = function () {
        var _this = this;
        return this.service.getTaste().then(function (res) {
            if (res.data.success) {
                _this.tasteList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getMouthFeels = function () {
        var _this = this;
        return this.service.getFlavor().then(function (res) {
            if (res.data.success) {
                _this.mouthfeels = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.getSupplierupperOptions = function (val) {
        var _this = this;
        var params = {
            keyword: val || ''
        };
        return this.supplierService.getSupplierupperOptions(params).then(function (res) {
            if (res.data.success) {
                var data = res.data.data || [];
                _this.supplierupperOptions = data;
            }
        });
    };
    default_1.prototype.filterSearch = function (val) {
        var _this = this;
        clearTimeout(this.time);
        this.time = setTimeout(function () {
            _this.getSupplierupperOptions(val);
        }, 500);
    };
    default_1.prototype.getInfor = function () {
        var _this = this;
        this.service.getGoodInfor({ goods_id: this.goodId }).then(function (res) {
            console.log(2222, res.data.data);
            if (res.data.success) {
                _this.goodModel = res.data.data;
                if (!_this.goodModel.product_area) {
                    _this.goodModel.product_area = undefined;
                }
                _this.goodModel.is_weigh = _this.goodModel.is_weigh.toString();
                _this.goodModel.purchase_is_weigh = _this.goodModel.purchase_is_weigh ? _this.goodModel.purchase_is_weigh.toString() : "0";
                _this.goodModel.sales_is_weigh = _this.goodModel.sales_is_weigh ? _this.goodModel.sales_is_weigh.toString() : "0";
                _this.goodModel.is_publish_list.is_publish_goods_tag = _this.goodModel.is_publish_list && _this.goodModel.is_publish_list.is_publish_goods_tag == 1 ? true : false;
                _this.goodModel.is_publish_list.is_publish_goods_pic = _this.goodModel.is_publish_list && _this.goodModel.is_publish_list.is_publish_goods_pic == 1 ? true : false;
                _this.goodModel.is_publish_list.is_publish_goods_explain = _this.goodModel.is_publish_list && _this.goodModel.is_publish_list.is_publish_goods_explain == 1 ? true : false;
                _this.goodModel.is_publish_list.is_publish_goods_sale = _this.goodModel.is_publish_list && _this.goodModel.is_publish_list.is_publish_goods_sale == 1 ? true : false;
                var check_type_1 = [];
                _this.goodModel.check_type.split(',').forEach(function (item) {
                    check_type_1.push(Number(item));
                });
                _this.goodModel.check_type = check_type_1;
                console.log(_this.goodModel.check_type);
                _this.goodModel.goods_brand_id = _this.goodModel.goods_brand_id == 0 ? '' : _this.goodModel.goods_brand_id;
                _this.goodModel.supplier_upper_id = _this.goodModel.supplier_upper_id == 0 ? '' : _this.goodModel.supplier_upper_id;
                _this.goodModel.storage_condition_range = _this.goodModel.storage_condition_range.map(function (item) {
                    return /^[-\d]+$/.test(item) ? item : undefined;
                });
                _this.editInforPro();
            }
            else {
                _this.$message.error(res.data.msg || "获取货品详情失败");
            }
        }, function (err) {
            _this.$message.error(err.message || "网络异常，请重试");
        });
    };
    default_1.prototype.editInforPro = function () {
        this.goodModel.is_publish = this.goodModel.is_publish == 1 ? true : false;
        this.goodModel.good_images = this.goodModel.main_pic;
    };
    default_1.prototype.refreshFormat = function () {
        var _this = this;
        this.service.getGoodInfor({ goods_id: this.goodId }).then(function (res) {
            if (res.data.success) {
                _this.goodModel.goods_format_list = res.data.data.goods_format_list;
            }
            else {
                _this.$message.error(res.data.msg || "获取辅助规格失败");
            }
        }, function (err) {
            _this.$message.error(err.message || "网络异常，请重试");
        });
    };
    default_1.prototype.addGoodsFormat = function () {
        this.goodModel.goods_format_list.push({
            goods_format_id: 0,
            goods_format_name: '',
            goods_format_code: '',
            sales_unit_id: 1,
            sales_unit_coefficient: '',
            edit: true
        });
    };
    default_1.prototype.deleteGoodsFormat = function (index) {
        this.goodModel.goods_format_list.splice(index, 1);
    };
    default_1.prototype.editFormat = function (index, flag) {
        GLOBAL_VUE.$set(this.goodModel.goods_format_list[index], 'edit', flag);
    };
    default_1.prototype.goodtypeFocus = function () {
        this.goodtypePanelShow = true;
    };
    default_1.prototype.goodtypeNodeClick = function (item) {
        this.goodtypePanelShow = false;
        this.goodModel.goods_type_id = item.goods_type_id;
    };
    default_1.prototype.containerClick = function () {
        this.goodtypePanelShow = false;
    };
    default_1.prototype.stopClick = function ($event) {
        $event.stopPropagation();
    };
    default_1.prototype.toTreeNodePosition = function (item) {
        this.$refs.treePanelWrapper.scrollTop = item.frontPosition.y - 30;
    };
    default_1.prototype.producerOpen = function () {
        this.$refs.selectUnit.visible = false;
    };
    default_1.prototype.handleCheckedChange = function (val) {
        console.log(val, this.goodModel.check_type);
    };
    default_1.prototype.isWeighChange = function () {
        if (this.goodModel.is_weigh == "1") {
            this.goodModel.purchase_is_weigh = "1";
            this.goodModel.sales_is_weigh = "1";
        }
        else {
            this.goodModel.purchase_is_weigh = "0";
            this.goodModel.sales_is_weigh = "0";
        }
        this.goodModel.purchase_weigh_unit_coefficient = "1";
        this.goodModel.sales_weigh_unit_coefficient = "1";
    };
    default_1.prototype.editorData = function (value) {
        this.storageExplain = value;
    };
    default_1.prototype.purchaseFormatSwitch = function () {
        if (this.purchaseFormatType == 1) {
            this.purchase_format_switch = Number(1 / +this.goodModel.purchase_format).toFixedNoZero(4);
            this.purchaseFormatType = 2;
        }
        else {
            this.goodModel.purchase_format = Number(1 / +this.purchase_format_switch).toFixedNoZero(4);
            this.purchaseFormatType = 1;
        }
    };
    default_1.prototype.saleUnitCoefficientSwitch = function () {
        if (this.salesUnitCoefficientType == 1) {
            this.sales_unit_coefficient_switch = Number(1 / +this.goodModel.sales_unit_coefficient).toFixedNoZero(4);
            this.salesUnitCoefficientType = 2;
        }
        else {
            this.goodModel.sales_unit_coefficient = Number(1 / +this.sales_unit_coefficient_switch).toFixedNoZero(4);
            this.salesUnitCoefficientType = 1;
        }
    };
    default_1.prototype.numberCheck = function (newVal) {
        console.log(newVal);
        return String(newVal).replace(/[^\d.]/g, '').replace(/^(.*\..{4}).*$/, "$1");
    };
    default_1.prototype.inputBlur = function (name) {
        console.log(name);
        switch (name) {
            case "purchase_format":
                this.goodModel.purchase_format = this.numberFormat(this.goodModel.purchase_format);
                break;
            case "purchase_format_switch":
                this.purchase_format_switch = this.numberFormat(this.purchase_format_switch);
                break;
            case "sales_unit_coefficient":
                this.goodModel.sales_unit_coefficient = this.numberFormat(this.goodModel.sales_unit_coefficient);
                break;
            case "sales_unit_coefficient_switch":
                this.sales_unit_coefficient_switch = this.numberFormat(this.sales_unit_coefficient_switch);
                break;
        }
    };
    default_1.prototype.numberFormat = function (number) {
        number = parseFloat(number);
        if (isNaN(number)) {
            number = 0;
        }
        return number;
    };
    default_1.prototype.taxTypeChange = function (node) {
        this.goodModel.tax_type_id = node.type_id;
        this.goodModel.tax_type_code = node.type_code;
        this.goodModel.tax_rate = node.tax_rate;
    };
    default_1.prototype.beforeAvatarUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "jpeg" || fileType == 'jpg' || fileType == "png"))) {
            this.$message.error("上传文件不符合格式，只能jpeg、jpg、png格式");
            return false;
        }
        ;
    };
    default_1 = __decorate([
        Component({
            components: {
                Uploader: Uploader,
                InputUploader: InputUploader,
                UE: UE,
                TreeSelectPanel: TreeSelectPanel,
                Specification: Specification,
                Editor: Editor
            },
            watch: {
                'goodModel.purchase_unit_id': function (newVal) {
                    var _this = this;
                    this.stdList.some(function (std) {
                        if (std.value == newVal) {
                            _this.purchasingUnit = std.name;
                            _this.goodModel.purchase_unit_name = std.name;
                            return true;
                        }
                    });
                },
                'goodModel.sales_unit_id': function (newVal) {
                    var _this = this;
                    this.stdList.some(function (std) {
                        if (std.value == newVal) {
                            _this.salesUnit = std.name;
                            return true;
                        }
                    });
                },
                'goodModel.inventory_unit_id': function (newVal) {
                    var _this = this;
                    this.stdList.some(function (std) {
                        if (std.value == newVal) {
                            _this.inventoryUnit = std.name;
                            return true;
                        }
                    });
                },
                'goodModel.goods_brand_id': function (newVal) {
                    var _this = this;
                    this.brandList.some(function (item) {
                        if (item.value == newVal) {
                            _this.goodModel.good_brand_name = item.name;
                        }
                    });
                },
                'goodModel.product_area': function (newVal) {
                    var _this = this;
                    this.producerList.some(function (item) {
                        if (item.id == newVal) {
                            _this.goodModel.product_area_name = item.name;
                            return;
                        }
                        else {
                            item.children.forEach(function (i) {
                                if (i.id == newVal) {
                                    _this.goodModel.product_area_name = i.name;
                                    return;
                                }
                                else {
                                    i.children && i.children.forEach(function (area) {
                                        if (area.id == newVal) {
                                            _this.goodModel.product_area_name = area.name;
                                            return;
                                        }
                                    });
                                }
                            });
                        }
                    });
                },
                'goodModel.storage_condition_id': function (val) {
                    this.updateStorageCondition(val);
                },
                'goodModel.purchase_format': function (newVal) {
                    this.goodModel.purchase_format = this.numberCheck(newVal);
                },
                'goodModel.sales_unit_coefficient': function (newVal) {
                    this.goodModel.sales_unit_coefficient = this.numberCheck(newVal);
                },
                'purchase_format_switch': function (newVal) {
                    this.purchase_format_switch = this.numberCheck(newVal);
                },
                'sales_unit_coefficient_switch': function (newVal) {
                    this.sales_unit_coefficient_switch = this.numberCheck(newVal);
                }
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
